import { myRxStompConfig } from './stomp.config';
import { StompService } from './stomp.service';

export function StompServiceFactory() {
  const rxStomp = new StompService();
  rxStomp.configure(myRxStompConfig);
  rxStomp.activate();
  return rxStomp;
}
